export {default} from './AirbnbCodeVerificationForm';



// WEBPACK FOOTER //
// ./src/containers/AirbnbCodeVerificationProcedure/private/AirbnbCodeVerificationForm/index.ts